"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Button = undefined;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _button = require("../config/data/button");

var _designSystemButtonStyles = require("../helpers/design-system-button-styles");

var _icon = require("../icon");

var _antButtonAsAny = require("./ant-button-as-any");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ButtonAndAntButton = function ButtonAndAntButton(_a) {
    var color = _a.color,
        props = __rest(_a, ["color"]);
    return React.createElement(_antButtonAsAny.AntButtonAsAny, __assign({}, props));
};
var Button = exports.Button = function Button(_a) {
    var icon = _a.icon,
        _b = _a.type,
        type = _b === void 0 ? _button.DEFAULT_BUTTON_TYPE : _b,
        _c = _a.color,
        color = _c === void 0 ? _button.DEFAULT_BUTTON_COLOR : _c,
        active = _a.active,
        props = __rest(_a, ["icon", "type", "color", "active"]);
    var buttonType = type;
    var buttonColor = color;
    var splitType = buttonType.split(_button.SPLIT_SEPARATOR);
    var iconPosition = splitType.includes(_button.CONTENT_LEFT) || splitType.includes(_button.DIRECT) ? _button.CONTENT_LEFT : _button.CONTENT_RIGHT;
    var displayIcon = icon || splitType.includes(_button.DIRECT) && _button.DEFAULT_DIRECT_ICON;
    var DesignSystemButton = (0, _styledComponents2.default)(ButtonAndAntButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n     ", "\n     ", "\n     ", "\n     ", "\n  "], ["\n     ", "\n     ", "\n     ", "\n     ", "\n  "])), _designSystemButtonStyles.getDesignSystemButtonBaseCss, _designSystemButtonStyles.getDesignSystemButtonSizeCss, _designSystemButtonStyles.getDesignSystemButtonColorCss, _designSystemButtonStyles.getDesignSystemButtonIconCss);
    if (type.includes(_button.EXPAND)) {
        return React.createElement(DesignSystemButton, __assign({ type: buttonType, color: buttonColor, "data-testid": _button.DEFAULT_TEST_ID }, props), React.createElement(_icon.Icon, { type: _button.DEFAULT_EXPAND_ICON }), React.createElement("span", null, props.children), React.createElement(_icon.Icon, { type: _button.DEFAULT_EXPAND_ICON }));
    }
    if (displayIcon) {
        if (iconPosition === _button.CONTENT_LEFT) {
            return React.createElement(DesignSystemButton, __assign({ type: buttonType, color: buttonColor, "data-testid": _button.DEFAULT_TEST_ID }, props), React.createElement("span", null, props.children), React.createElement(_icon.Icon, { type: displayIcon }));
        }
        return React.createElement(DesignSystemButton, __assign({ type: buttonType, color: buttonColor, "data-testid": _button.DEFAULT_TEST_ID }, props), React.createElement(_icon.Icon, { type: displayIcon }), React.createElement("span", null, props.children));
    }
    return React.createElement(DesignSystemButton, __assign({ type: buttonType, color: buttonColor, "data-testid": _button.DEFAULT_TEST_ID }, props), React.createElement("span", null, props.children));
};
var templateObject_1;
//# sourceMappingURL=button.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/button/button.js
// module id = 524
// module chunks = 0